import type { ReactNode } from 'react';

interface Props {
    index: number;
    value: number;
    children: ReactNode;
}

export default function CustomTabPanel({ children, value, index }: Props) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <>{children}</>}
        </div>
    );
}
